import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { whatsappHref } from "@/lib/contact";

export const WHATSAPP_SUNIL = whatsappHref(
  "Hi Ashish, I'm contacting the Homewiz.in independent advisory desk about Fairfox EON investment opportunities. Please share current options."
);

const LINKS = [
  { label: "EON", hash: "#top" },
  { label: "Why EON", hash: "#why-eon" },
  { label: "Primary", hash: "#primary-resale" },
  { label: "Resale", hash: "#primary-resale" },
  { label: "Investment", hash: "#calculator" },
  { label: "Location", hash: "#location" },
];

export const scrollToHash = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, hash) => {
    e.preventDefault();
    scrollToHash(hash);
  };

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0B0C0E]/80 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo onClick={(e) => go(e, "#top")} />
        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.hash}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={(e) => go(e, l.hash)}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#9CA3AF] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP_SUNIL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="px-5 py-2.5 bg-[#D4AF37] text-[#0B0C0E] font-sans text-xs font-semibold uppercase tracking-[0.15em] rounded-full hover:bg-[#F3E5AB] hover:shadow-[0_0_24px_rgba(212,175,55,0.4)] transition-all duration-300 flex items-center gap-2"
          >
            <MessageCircle size={13} />
            WhatsApp
          </a>
          <a
            href="#visit"
            data-testid="nav-book-visit-btn"
            onClick={(e) => go(e, "#visit")}
            className="hidden sm:block px-5 py-2.5 border border-[#D4AF37]/40 text-[#F3F4F6] font-sans text-xs font-semibold uppercase tracking-[0.15em] rounded-full hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all duration-300"
          >
            Request Site Visit
          </a>
        </div>
      </div>
    </motion.header>
  );
}
